import {
  paths,
  settingsResponseSchema,
  type SettingsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/**
 * Logo 不进 `PUT /api/settings` 的整份覆盖：图片塞不进那份 JSON，走自己的端点。
 * 什么时候传由页面定：Settings 攒到按下保存才调这里（PRD 4.1）。
 */
export const saveSettingsLogoOperation = "settings.logo.save";

export type SaveSettingsLogoOperation = typeof saveSettingsLogoOperation;

export type SaveSettingsLogoFailure = BackendFailure<SaveSettingsLogoOperation>;

/** 后端只认这三种，`accept` 和这里用同一份。 */
export const LOGO_ACCEPT = "image/png,image/jpeg,image/webp";

export const LOGO_MAX_BYTES = 2 * 1024 * 1024;

/** 传 `null` 就是移除。两条路都回整份配置，页面拿到的永远是最新的 logoUrl。 */
export function saveSettingsLogo(
  file: File | null,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<SettingsResponse, SaveSettingsLogoFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    // 文件原样发，不做 multipart：只有一个文件，没有别的字段要带。
    headers: file === null ? undefined : { "Content-Type": file.type },
    method: file === null ? "DELETE" : "POST",
    operation: saveSettingsLogoOperation,
    parse: (payload) => settingsResponseSchema.parse(payload),
    path: paths.settingsLogo,
    rawBody: file ?? undefined,
    signal: options.signal,
  });
}
